import React from 'react';

export type Period = 'Month' | 'Year' | 'AllTime';

type Props = {
  period: Period;
  setPeriod: React.Dispatch<React.SetStateAction<Period>>;
  canSelect: boolean;
};

const periodToTabTitle = (period: Period): string => {
  switch (period) {
    case 'Month':
      return '月';
    case 'Year':
      return '年';
    case 'AllTime':
      return '全期間';
  }
};

const PeriodTab = ({
  period,
  selected,
  setPeriod,
  canSelect,
}: {
  period: Period;
  selected: Period;
  setPeriod: (period: Period) => void;
  canSelect: boolean;
}): React.ReactElement => {
  const isSelected = selected === period;
  const id =
    period === 'Month'
      ? 'target_month'
      : period === 'Year'
      ? 'target_year'
      : period === 'AllTime'
      ? 'target_all'
      : '';

  return (
    <>
      <div
        id={`${id}`}
        className={`rounded-t overflow-hidden ${
          canSelect ? 'hover:cursor-pointer' : ''
        }`}
        onClick={(): void => {
          canSelect && setPeriod(period);
        }}>
        <div
          className={`${isSelected ? '' : 'bg-transparent'} h-1`}
          style={{
            ...(isSelected ? { backgroundColor: '#3480ce' } : {}),
          }}></div>
        <div
          className={`py-2 font-bold flex flex-row items-center justify-center ${
            isSelected ? 'bg-white' : 'bg-gray-300 cursor-pointer'
          } ${canSelect ? '' : 'text-gray-400'}`}>
          {periodToTabTitle(period)}
        </div>
      </div>
    </>
  );
};

export const PeriodTabs = ({
  period,
  setPeriod,
  canSelect,
}: Props): React.ReactElement => {
  return (
    <>
      <div className="px-4">
        <div
          className="grid gap-2"
          style={{ gridAutoFlow: 'column', gridAutoColumns: '1fr' }}>
          <PeriodTab
            selected={period}
            period="Month"
            setPeriod={setPeriod}
            canSelect={canSelect}
          />
          <PeriodTab
            selected={period}
            period="Year"
            setPeriod={setPeriod}
            canSelect={canSelect}
          />
          <PeriodTab
            selected={period}
            period="AllTime"
            setPeriod={setPeriod}
            canSelect={canSelect}
          />
        </div>
      </div>
    </>
  );
};
